// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateModalVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isFullDebitModalVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_RECORD_AUDIT_FULL_DEBIT_MODAL_VISIBILITY]: updateModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/reducers/full-debit-modal.js